import { render, staticRenderFns } from "./ot-combo-box.vue?vue&type=template&id=a66ceb70&scoped=true&"
import script from "./ot-combo-box.vue?vue&type=script&lang=ts&"
export * from "./ot-combo-box.vue?vue&type=script&lang=ts&"
import style0 from "./ot-combo-box.vue?vue&type=style&index=0&id=a66ceb70&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a66ceb70",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCombobox } from 'vuetify/lib/components/VCombobox';
installComponents(component, {VCombobox})
